import React from "react";
import { Target, Boxes, Gem, Clock } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { MEDIA } from "@/constants/media";
import { Reveal, Overline } from "@/components/Reveal";

const ICONS = [Target, Boxes, Gem, Clock];

const WhyChooseUs = () => {
  const { t } = useSite();
  const w = t.why;

  return (
    <section id="why" data-testid="why-section" className="relative overflow-hidden py-24 lg:py-32">
      {/* Layered background image */}
      <div className="absolute inset-0 -z-10">
        <img src={MEDIA.machine1} alt="" className="h-full w-full object-cover opacity-[0.12]" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/85 to-background" />
      </div>

      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal className="flex flex-col items-center">
            <Overline>{w.overline}</Overline>
            <h2 className="mt-6 font-heading text-4xl font-light leading-tight tracking-tight sm:text-5xl">
              {w.title}
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {w.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div
                  data-testid={`why-card-${i}`}
                  className="group h-full border border-border bg-card/40 p-8 backdrop-blur-sm transition-colors duration-500 hover:border-gold"
                >
                  <Icon size={30} strokeWidth={1.3} className="text-gold" />
                  <h3 className="mt-6 font-heading text-2xl font-normal">{item.title}</h3>
                  <p className="mt-3 font-body text-sm font-light leading-relaxed text-muted-foreground">
                    {item.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
